import PropsType from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";

function NavLink({ label, to, icon }) {
    if (to) {
        return (
            <Link
                component={RouterLink}
                underline="hover"
                color="inherit"
                sx={{ display: "flex", alignItems: "center" }}
                to={to}
            >
                {icon}
                {label}
            </Link>
        );
    }
    return <div>{label}</div>;
}

NavLink.propsType = {
    label: PropsType.string,
    to: PropsType.string,
    icon: PropsType.element,
};

export default NavLink;
